import { gql } from '@apollo/client'

export default gql`
  mutation mortgageWidgetFetchProducts(
    $input: MortgageWidgetSubmissionInput
    $productTypes: [MortgageWidgetProductTypeEnum!]
    $lenderCentricProducts: Boolean
    $sortingField: MortgagesMortgageSortingTypeEnum #required for lender centric products
    $bestProduct: Boolean #required for lender centric products
    $loanTypes: [WidgetLoanTypeEnum!]
  ) {
    mortgageWidgetFetchProducts(
      input: $input
      lenderCentricProducts: $lenderCentricProducts
      sortingField: $sortingField
    ) {
      uuid
      ficoType
      zipCode
      vertical
      estimatedValue
      status
      downPayment
      homeValue
      loanAmount
      occupancyType
      propertyType
      cashOut
      products(productTypes: $productTypes, loanTypes: $loanTypes, bestProduct: $bestProduct) {
        closingCost
        discount
        uuid
        externalProductId
        lender {
          name
          nmls
          slug
          purchaseRating
        }
        productType
        monthlyPayment
        loanTerm
        loanType
        amortizationType
        rate
        apr
        fees
        bestProduct
      }
    }
  }
`
